import { useLoginOnStartup } from '@micro-frontend-react/employee-experience/lib/useLoginOnStartup';
import * as React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { CoherenceThemeProvider } from './Components/CoherenceThemeProvider';
import { Header } from './Components/Header';
import { Main } from './Components/Main';
import { Nav } from './Components/Nav';
import { navConfig } from './navConfig';
import { Routes } from './Routes';
import { ShellWithStore } from './ShellWithStore';
import { useHeaderConfig } from './useHeaderConfig';

const getMfeOverrides = (isNavCollapsed: boolean) => `
  #app > div {
    height: initial;
  }

  nav[role='navigation'] {
    width: ${isNavCollapsed ? '48px' : '228px'} !important;
    overflow-x: hidden;
    transition: width 0.2s;
  }

  nav[role='navigation'] > div {
    width: ${isNavCollapsed ? '48px' : '228px'} !important;
    overflow-x: hidden;
    scrollbar-width: none;
  }

  nav[role='navigation'] > div::-webkit-scrollbar {
    display: none;
  }
`;

function App(): React.ReactElement {
  useLoginOnStartup();
  const headerConfig = useHeaderConfig();
  const [isNavCollapsed, setIsNavCollapsed] = React.useState(true);


  return (
    <CoherenceThemeProvider>
      <style>
        {getMfeOverrides(isNavCollapsed)}
      </style>
      <BrowserRouter>
        <Header {...headerConfig} />
        <Nav groups={navConfig} onNavCollapsed={setIsNavCollapsed} />
        <Main $isNavCollapsed={isNavCollapsed}>
          <Routes />
        </Main>
      </BrowserRouter>
    </CoherenceThemeProvider>
  );
}

render(
  <ShellWithStore>
    <App />
  </ShellWithStore>,
  document.getElementById('app')
);
